<template>
  <form @submit="submitForm">
    <div class="mt-30">
      <label
          for="company"
          class="wfh-form-label"
          :class="{'text-danger': companyError}"
      >
        Company Name
      </label>
      <input
          required
          class="form-control wfh-input-box"
          :class="{'is-invalid': companyError}"
          style="background-image: none !important;"
          type="text"
          id="company"
          v-model="companyName"
          :readonly="hasCompany"
      />
      <span v-if="companyError" v-text="companyError" class="wfh-err-label"></span>
    </div>

    <div class="mt-30">
      <label for="name" class="wfh-form-label">
        What's your name?
      </label>
      <input
          required
          autofocus
          autocomplete="name"
          class="form-control wfh-input-box"
          style="background-image: none !important;"
          type="text"
          id="name"
          v-model="formData.name"/>
    </div>

    <div class="mt-30">
      <label
          for="designation"
          class="wfh-form-label"
          :class="{'text-danger': designationError}"
      >
        Designation
      </label>
      <input
          required
          placeholder="eg: Software Engineer, Manager, Intern"
          class="form-control wfh-input-box"
          :class="{'is-invalid': designationError}"
          style="background-image: none !important;"
          type="text"
          id="designation"
          v-model="formData.designation"
      />
      <span v-if="designationError" v-text="designationError" class="wfh-err-label"></span>
    </div>

    <div class="text-center">
      <button
          type="submit"
          class="btn wfh-btn-primary position-relative"
          style="margin-top: 30px;"
      >
        Continue
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    company: {
      required: false,
    },
  },

  data () {
    return {
      formData: {
        name: '',
        designation: '',
      },
      companyName: '',
      emailError: null,
      passwordError: null,
      companyError: null,
      designationError: null,
      viewPassword: false,
      loading: false,
    };
  },

  computed: {
    hasCompany () {
      return !!this.company;
    },
  },

  methods: {
    async submitForm (e) {
      e.preventDefault();

      await axios.post(window.location.pathname, this.formData);

      window.location = '/dashboard';
    },
  },

  mounted () {
    if (this.hasCompany) {
      const company = this.company;
      this.companyName = company.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.mt-30 {
  margin-top: 30px;
}
</style>
